import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import AdminHubBreadcrumbs from './AdminHubBreadcrumbs';
import '../../pages/AdminDashboard.css';
import './AdminHubUiKit.css';

/**
 * @param {{
 *   titleKey: string,
 *   descKey?: string,
 *   breadcrumbItems?: Array<{ label: string, to?: string }>,
 *   children: React.ReactNode,
 * }} props
 */
export default function AdminHubPageFrame({ titleKey, descKey, breadcrumbItems, children }) {
  const { t, isRTL } = useLanguage();
  return (
    <div className={`admin-dashboard admin-hub-page ${isRTL ? 'rtl' : 'ltr'}`} dir={isRTL ? 'rtl' : 'ltr'}>
      <header className="admin-hero">
        {breadcrumbItems?.length ? <AdminHubBreadcrumbs items={breadcrumbItems} /> : null}
        <h1 className="admin-hero__title">{t(titleKey)}</h1>
        {descKey ? <p className="admin-hero__subtitle">{t(descKey)}</p> : null}
      </header>
      {children}
    </div>
  );
}
